module.exports = __webpack_public_path__ + "static/everything-is-connected-ii_acrylic-on-canvas-36x36in-2016-929525bca5151cbc8b67290178405181.jpg";